module.exports = __webpack_public_path__ + "static/media/icon-report-sidebar-insight.b1023661.svg";